import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import CustomInput from "../../../../Components/UI/Inputs/CustomInput";
import BoltButton from "../../../../Components/UI/Buttons/BoltButton";
import { updatePasswordByAdmin } from "../../../../services/AdminServices/Users/users.services";
import { showSnackBar } from "../../../../store/common/snackBarSlice";
import { useTranslation } from "react-i18next";

const initialData = {
  user_id: "",
  password: "",
};

const ResetPassword = ({ shipperData }) => {
  const { t } = useTranslation("admin");
  const dispatch = useDispatch();
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleUpdate = async () => {
    if (!data.password) {
      dispatch(
        showSnackBar({
          text: t("controls.pleaseEnterANewPassword"),
          severity: "error",
        })
      );
      return;
    }

    setLoading(true);
    const response = await updatePasswordByAdmin(data);
    setLoading(false);

    if (!response?.data?.status || response.error) {
      dispatch(
        showSnackBar({
          text: t("controls.somethingWentWrong"),
          severity: "error",
        })
      );
    } else {
      setData(initialData);
      dispatch(
        showSnackBar({
          text: t("controls.passwordUpdatedSuccessfully"),
          severity: "success",
        })
      );
    }
  };

  useEffect(() => {
    if (shipperData) {
      setData({ ...data, user_id: shipperData.id });
    }
  }, [shipperData]);

  if (!shipperData) {
    return null;
  }

  return (
    <div className="space-y-6">
      {/* New Password Field */}
      <div className="max-w-md">
        <CustomInput
          label={t("controls.newPassword")}
          type="password"
          value={data.password}
          onChange={handleChange}
          name="password"
          placeholder={t("controls.enterNewPassword")}
          required
        />
      </div>

      {/* Reset Password Button */}
      <div className="max-w-md">
        <BoltButton
          label={t("controls.resetPassword")}
          variant="primary"
          size="lg"
          onClick={handleUpdate}
          disabled={loading}
          loading={loading}
          className="px-8 py-2 text-lg font-semibold min-w-[120px] w-full sm:w-auto justify-center"
        />
      </div>
    </div>
  );
};

export default ResetPassword;
